<section class="w-full">
  <!-- Banner/Heading section -->
  <app-banner_section-type01 [options]="{title:'', imageHref:view.imageHref}">

  </app-banner_section-type01>

  <!-- Header (Title/Tagline) section -->
  <div class="flex flex-col items-center justify-center mb-4 md:mt-5">
    <div class="w-full flex justify-center items-center">
      <div class="flex flex-col justify-center items-center mt-5 sm:pl-5 sm:pr-5 sm:items-center text">
        @if (view.site && view.site.profile && view.site.profile.heading) {
        @switch (view.site.profile.heading.position) {
        @case (1) {
        <app-heading_section-type01
          [options]="{heading:'Our Specials',title:'Unbeatable Package Specials',image:'', description:'',headingStyle: {'text-align': 'center'},swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
        }
        <!-- @case (3) {
        <app-heading_section-type01 [options]="{heading:'Our Specials',title:'',image:'assets/xltravel/swoosh-01.svg', description:'',headingStyle: {'text-align': 'center'},swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
        } -->
        @case (3) {
        <div class="mb-3 md:mb-8 flex flex-col items-center justify-center text-center">
          <p
            class="text-3xl md:text-5xl lg:text-7xl font-light font-primary tracking-tight text-gray-900 dark:text-gray-200">
            Our
            <strong>Specials</strong> Section
          </p>
          <img class="w-50 md:w-100" src="assets/xltravel/swoosh-01.svg" alt="xl underline">
        </div>
        }
        @case (4) {
        <app-heading_section-type01
          [options]="{ heading:'Our Specials',title:'Top-Quality Specials',image:'', description:'' }"></app-heading_section-type01>
        }
        }
        }
      </div>
    </div>
  </div>

  @if(!view.allSpecialsCombined && view.promotionalFiles) {
  <div class="flex flex-col items-center justify-center mb-10 md:mt-5 lg:mt-10">
    <div class="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-primary-500"></div>
  </div>
  }

  <!-- Cards/Grid Layout section -->
  <div class="grid grid-cols-1 gap-4 py-4 md:grid-cols-3 sm:grid-cols-2 px-10">
    <div *ngFor="let item of view.allSpecialsCombined let i = index"
      class="relative cursor-pointer group aspect-square bg-gray-300 rounded-lg" (click)="openModal(item, i)">
     <img [src]="item.image" alt="Flyer image" class="w-full h-full object-cover rounded-lg">
    </div>
  </div>

  @if(view.promotionalFiles.length <= 0) { <div class="flex justify-center items-center mb-30">
    <h1 class="text-black tracking-wider text-3xl md:text-5xl">Fresh specials are on the way!</h1>
    </div>
    }

    <!-- LMS Modal section -->
    <div *ngIf="modalOpen"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] overflow-auto p-4">
      <div
        class="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-7xl relative flex flex-col md:flex-row max-h-[90vh] overflow-y-auto">

        <!-- Close Button -->
        <mat-icon class="absolute top-2 right-2 icon-size-8 bg-primary-500 text-white p-2 rounded-full cursor-pointer"
          (click)="closeModal()" svgIcon="close"></mat-icon>

        <div class="grid grid-cols-1 md:grid-cols-2">
          <!-- Left: Image Slider Section -->
          <div class="w-full px-4 flex items-center justify-center h-full">
            <ngx-slick-carousel #slickModal="slick-carousel" [config]="slideConfig" class="w-full">
              <div ngxSlickItem *ngFor="let slide of selectedItem.images" class="relative px-2">
                <img [src]="slide?.fileUrl" alt="flyer image"
                  class="w-full h-full object-contain rounded-md max-h-[600px]" />
              </div>
            </ngx-slick-carousel>
          </div>

          <!-- Right: Enquiry Form Section -->
          <div class="w-full pb-4 pt-2 flex flex-col justify-center items-center h-full">
            <h2 class="text-gray-900 text-2xl font-medium dark:text-gray-200">Reach Us</h2>
            <!-- <h2 class="text-gray-900 text-lg font-medium dark:text-gray-200">{{selectedItem.name}}</h2>  -->
            <form (ngSubmit)="sendMessage()" class="flex flex-col w-full">
              <div>
                <label for="name" class="leading-7 text-sm text-gray-600 dark:text-gray-300">Name</label>
                <input type="text" id="name" name="name" placeholder="First Name.." class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 
                       focus:border-red-500 focus:ring-2 focus:ring-red-200 text-base 
                       outline-none text-gray-700 py-2 px-3 transition-colors duration-200 ease-in-out"
                  [(ngModel)]="view.message.firstName" required>
              </div>

              <div>
                <label for="lastName" class="leading-7 text-sm text-gray-600 dark:text-gray-300">Last Name</label>
                <input type="text" id="lastName" name="lastName" placeholder="Last Name.." class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 
                       focus:border-red-500 focus:ring-2 focus:ring-red-200 text-base 
                       outline-none text-gray-700 py-2 px-3 transition-colors duration-200 ease-in-out"
                  [(ngModel)]="view.message.lastName" required>
              </div>

              <div>
                <label for="email" class="leading-7 text-sm text-gray-600 dark:text-gray-300">Email</label>
                <input type="email" id="email" name="email" placeholder="Email address..." class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 
                       focus:border-red-500 focus:ring-2 focus:ring-red-200 text-base 
                       outline-none text-gray-700 py-2 px-3 transition-colors duration-200 ease-in-out"
                  [(ngModel)]="view.message.emailAddress" required>
              </div>

              <div>
                <label for="phone" class="leading-7 text-sm text-gray-600 dark:text-gray-300">Phone</label>
                <input type="text" id="phone" name="phone" placeholder="Phone number..." class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 
                       focus:border-red-500 focus:ring-2 focus:ring-red-200 text-base 
                       outline-none text-gray-700 py-2 px-3 transition-colors duration-200 ease-in-out"
                  [(ngModel)]="view.message.phoneNumber" required>
              </div>

              <div>
                <label for="message" class="leading-7 text-sm text-gray-600 dark:text-gray-300">Message</label>
                <textarea id="message" name="message" placeholder="Your message..."
                  class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 
                       focus:border-red-500 focus:ring-2 focus:ring-red-200 h-18 text-base 
                       outline-none text-gray-700 py-2 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out" [(ngModel)]="view.message.comments" required></textarea>
              </div>

              <div>
                <button [ngClass]="{ 'bg-accent-500 text-gray-500 cursor-not-allowed': !isFormValid(),
                              'bg-accent-500 text-primary-100 cursor-pointer hover:text-primary-500 hover:bg-primary-100 transition ease-out duration-500': isFormValid()
                              }" class="w-full rounded-xl uppercase font-semibold p-3 border-2 border-accent-500"
                  type="submit">
                  {{isFormValid() ? 'Send Message Now' : 'Complete all fields'}}
                </button>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
</section>
